import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpStatus } from '../enums/http-erors';
import { ToastMessageService } from '../services/toast-message.service';
import { StorageService } from '../services/storage.service';



export const errorInterceptor: HttpInterceptorFn = (req, next) => {

  let routerService = inject(Router);
  let toastMessageService = inject(ToastMessageService);
  let storageService = inject(StorageService);
  let errorMessage: any = "";

  return next(req).pipe(map(
    (event: HttpEvent<any>) => {
      return event;
    }
  ),
    catchError(
      (error: any) => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case HttpStatus.NetworkError:
              errorMessage = 'Network error. Please check your internet connection.';
              break;
            case HttpStatus.BadRequest:
              errorMessage = 'Bad Request. Please check your input.';
              break;
            case HttpStatus.NotFound:
              errorMessage = 'The requested resource was not found.';
              break;
            case HttpStatus.ServerError:
              errorMessage = 'Server error. Please try again later.';
              break;
            case HttpStatus.Unauthorized:
              errorMessage = 'Unauthorized access. Redirecting to login.';
              storageService.logout();
              routerService.navigate(['/login']);
              break;
            default: {
              if (error.error?.message) {
                errorMessage = error.error?.message;
              } else if (Array.isArray(error?.error?.Error)) {
                errorMessage = error?.error?.Error[0];

              } else if (Object.keys(error.error?.Error).length > 0) {
                errorMessage = Object.entries(error.error?.Error)[0][1];
              } else {
                errorMessage = "Something went wrong, Please try again later";
              }
              break;
            }
          }

          toastMessageService.toastOnError('Error', errorMessage);
        }
        return throwError(() => error);
      })
  );
};
